mp.localtime = {
    timeout: null,
    current: [],

    init: function (prefix) {
        if ($(prefix + '.mpLocalTime').length > 0) {
            $(prefix + '.mpLocalTime').each(function () {
                var ref = $(this);
                mp.localtime.current.push({
                    prefix: prefix,
                    ref: ref,
                    time: parseInt(ref.data('localtime')) * 1000
                });
            });
            if (mp.localtime.timeout == null) {
                mp.localtime.timeout = setTimeout(mp.localtime.count, 1000);
            }
        }
    },

    count: function () {
        for (var i in mp.localtime.current) {
            mp.localtime.current[i].time += 1000;
        }
        setTimeout(mp.localtime.count, 1000);
        mp.localtime.display();
    },

    display: function () {
        for (var i in mp.localtime.current) {
            if (mp.localtime.current[i].ref.is(':visible')) {
                var time = new Date(mp.localtime.current[i].time);

                // Info: ein fehlerhaftes Zeitformat fällt wohl immer auf en-US zurück
                mp.localtime.current[i].ref.html(time.toLocaleDateString(mpData.currentLang) + ' ' + time.toLocaleTimeString(mpData.currentLang));
            }
        }
    },

    remove: function (prefix) {
        var array = [];
        for (var i in mp.localtime.current) {
            if (prefix !== mp.localtime.current[i].prefix) {
                array.push(mp.localtime.current[i]);
            }
        }
        mp.localtime.current = array;
    }
};

$(document).ready(function () {
    mp.localtime.init('');
});